var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CountDownAlert'),_c('AnnouncementSlider',{staticClass:"bg-image-size"}),_c('ProductsSlider',{staticClass:"m-5",attrs:{"products":_vm.all_products,"title":_vm.title,"id":"graduates"}}),_c('AboutUs',{staticClass:"my-5"}),_c('Visitanos'),_c('Info'),_c('Checker')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }